import { UserListingModel } from '../UserListingModel';

/**
 * This is a hospital schedule specific veterinarian model that extends the new VeterinarianListingModel, a lighter weight vet model
 * It is returned by the new hospital schedule end point.  Whether the vet has a DVM license for a hospital state or has access to the hospital
 * can be determined here.  But note, the activeDVMLicenseHospitalIds and accessibleHospitalIds are populated by getHospitalSchedule's response payload only for the requested hospitals on the request.
 * I.e. if you only request the schedule for hospital id 1205, you'll only have license and access info for hospital 1205, that's because vet's are only included if they're on the schedule for hospital 1205 or have access to hospital 1205.
 */
export class HospitalScheduleVetTechModel extends UserListingModel {
  accessibleHospitalIds: number[];

  constructor(init: Partial<HospitalScheduleVetTechModel>) {
    super(init);
    this.accessibleHospitalIds =
      init?.accessibleHospitalIds?.map((id) => id) ?? ([] as number[]);
  }
}
